module.exports = __webpack_public_path__ + "static/media/39.3a594e7a.png";